'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.write = exports.read = undefined;

var _parser = require('./parser');

var _packer = require('./packer');

var read = exports.read = function read(buffer, options) {
  return (0, _parser.ParserSync)(buffer, options || {});
};

var write = exports.write = function write(png, options) {
  return (0, _packer.PackerSync)(png, options);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/pngjs3/dist/png-sync.js
// module id = 1097
// module chunks = 0